<div class="modal-header">

  <p class="modal-title"><strong> Notifications</strong></p>
    <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

</div>

<div class="modal-body">
  <div class="table-responsive-sm">

    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Employee Name</th>
          <th>Message<small style="color:red">*</small></th>
          <th>Date added <span style="float:right;color:red"><small>*Click on the message to view the update</small></span></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data.notificationGridList">
          <td>
            <a href="javascript:void(0)" (click)="navigateAction(item.id,item.url)" routerLinkActive="active">
              {{ item.name }}
            </a>
          </td>
          <td>
            <a style="color:blue !important" href="javascript:void(0)" (click)="navigateAction(item.id,item.url)" routerLinkActive="active">
              {{ item.message }}
            </a>
          </td>
          <td>
              {{ item.dateAdded }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="data.notificationGridList.length==0" class="row p-3">
    <div class="col text-center text-dark">
      <p class="h6 font-weight-bold text-muted">No notifications to show!</p>
    </div>
  </div>

  <div class="row" *ngIf="data.notificationGridList.length>0">
    <div class="col-xs-10 col-10">
      <pagination [totalItems]="data.sortParams.totalRecords"
                  [itemsPerPage]="data.sortParams.itemsPerPage" [maxSize]="20" [(ngModel)]="currentPage"
                  (pageChanged)="pageChanged($event)"></pagination>
    </div>

    <div class="col-xs-2 col-2">
      <select (change)="onSelectChanges()" [(ngModel)]="data.sortParams.itemsPerPage"
              class="form-control form-control-sm">
        <option *ngFor="let count of changeCount" [value]="count">{{count}}</option>
      </select>
      <p>Per page</p>
    </div>
  </div>
</div>


